// pwa/src/components/Locations.js
import React, { useContext, useEffect, useState, useRef } from "react";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import { DataGrid, GridActionsCellItem, GridRowId } from "@mui/x-data-grid";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import LocationModalContent from "./LocationModalContent";
import QRGridPdf from "./QRGridPdf";
// import DOMPurify from 'dompurify';
import Grid from "@mui/material/Grid";
import { Button, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";

const Locations = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [locations, setLocations] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const modalContentRef = useRef();
  const [productToEditId, setProductToEditId] = useState(null);
  const [qrLinks, setQrLinks] = useState([]);

  const handleOpenModalContent = () => {
    setProductToEditId(null); // Asegurarse de que no haya ID de producto para edición
    modalContentRef.current?.handleClickOpen();
  };

  const getLocations = () => {
    const { page, pageSize } = paginationModel;

    let sortParams = "";
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      sortParams = `&sortField=${field}&sortOrder=${sort}`;
    }

    axios
      .get("/api/locations?page=" + page + "&pageSize=" + pageSize + sortParams)
      .then((response) => {
        setLocations(response.data.locations);
        setTotalRows(response.data.total);
        const qrData = response.data.locations.map((loc) => ({
          id: loc.id,
          url: loc.hashId
            ? process.env.REACT_APP_FRONT_URL + "/qr/" + loc.hashId
            : "",
          text: loc.name || "",
        }));
        setQrLinks(qrData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEditClick = (id) => {
    setProductToEditId(id); // Establecer el ID del producto a editar
    modalContentRef.current?.handleClickOpen();
    console.log("Edit clicked for row:", id);
  };

  const handleDeleteClick = (id) => {
    console.log("Delete clicked for row:", id);
  };

  // Callback para manejar la recarga de la lista después de guardar en el modal
  const handleModalSaveSuccess = () => {
    getLocations();
  };

  useEffect(() => {
    getLocations();
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({ id: "app.header.locations.label" }),
        },
      ]);
    }
  }, [paginationModel, sortModel]); // Se ejecuta cuando cambia la paginación o la ordenación

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Name", width: 100 },
    { field: "active", headerName: "Active", width: 100, type: "boolean" },
    {
      field: "gpsRequired",
      headerName: "GPS Required",
      width: 100,
      type: "boolean",
    },
    { field: "description", headerName: "Description", flex: 1 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "right" }}>
            <QRGridPdf
              links={qrLinks}
              rows={2}
              cols={2}
              qrWidth={4}
              qrHeight={4}
              gapX={2}
            />
            <Button
              variant="contained"
              size="small"
              onClick={handleOpenModalContent}
              sx={{ mr: 1 }}
            >
              <FormattedMessage
                id={"app.content.create.label"}
                defaultMessage={"Crear"}
              />
            </Button>
          </Grid>

          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "center" }}>
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={locations}
                columns={columns}
                pagination
                paginationMode="server"
                sortingMode="server"
                rowCount={+totalRows}
                pageSizeOptions={[5, 10, 25, 50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                sortModel={sortModel}
                onSortModelChange={(model) => setSortModel(model)}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={1}></Grid>
        </Grid>
        <LocationModalContent
          shopId={context.user.shopId || null}
          productId={productToEditId}
          ref={modalContentRef}
          onSaveSuccess={handleModalSaveSuccess}
        />
      </Container>
    </Layout>
  );
};

export default Locations;
